function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import primitives from '@veneer/primitives';
import { semantics as defaultSemantics } from '@veneer/semantics';
import defaultTheme from '../default_theme';
import { typography } from './typography';
function getSupportedMode(mode) {
  return mode === 'contrast' ? 'highContrast' : mode;
}
function getDefaultMode(mode) {
  switch (mode) {
    case 'light':
    case 'dark':
      return mode;
    case 'contrast':
      return 'highContrast';
    default:
      return 'light';
  }
}
export default function createTheme(_ref) {
  var _customSemantics$colo;
  var {
    density = 'standard',
    mode = 'light',
    outerTheme = {},
    shape = 'round',
    customSemantics
  } = _ref;
  var supportedMode = getSupportedMode(mode);
  var defaultMode = getDefaultMode(mode);
  var palette = (customSemantics === null || customSemantics === void 0 || (_customSemantics$colo = customSemantics.color) === null || _customSemantics$colo === void 0 ? void 0 : _customSemantics$colo[supportedMode]) || defaultSemantics.color[defaultMode];
  var densityVars = defaultTheme.density[density];
  var shapeVars = defaultTheme.shape[shape] || {};
  if (Object.keys(outerTheme).length > 0) {
    densityVars = _objectSpread(_objectSpread({}, densityVars), outerTheme.density ? outerTheme.density[density] : {});
    shapeVars = _objectSpread(_objectSpread({}, shapeVars), outerTheme.shape ? outerTheme.shape[shape] : {});
  }
  var {
    color: primitivesColor
  } = primitives;
  var finalColor = _objectSpread(_objectSpread({}, palette), primitivesColor);
  var finalElevation = _objectSpread(_objectSpread({}, (customSemantics === null || customSemantics === void 0 ? void 0 : customSemantics.elevation) || defaultSemantics.elevation), defaultTheme.elevation);
  var finalLayout = _objectSpread({}, defaultTheme.layout);
  var finalTypography = _objectSpread(_objectSpread({}, primitives.typography), typography(defaultSemantics));
  return _objectSpread(_objectSpread(_objectSpread({}, densityVars), shapeVars), {}, {
    color: finalColor,
    density,
    elevation: finalElevation,
    layout: finalLayout,
    mode,
    shape,
    typography: finalTypography
  });
}